// plugins/confirm.client.ts

// import { defineNuxtPlugin } from '#app'
import { createApp, h } from 'vue'
import ConfirmDialog from '@/components/common/confirmdialog.vue'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('confirm', (options: {
        title?: string
        message: string
        sessionLabel?: string
    }): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            // Créez un container pour le composant dynamique
            const container = document.createElement('div')
            document.body.appendChild(container)

            // Même thème que plugins.ts — sans ça, Vuetify injecte le primary Material
            // (bleu clair) dans le document et les chips/icônes de l'app changent de couleur.
            const vuetify = createVuetify({
                components,
                directives,
                theme: {
                    defaultTheme: 'myDitTheme',
                    themes: {
                        myDitTheme: {
                            dark: false,
                            colors: {
                                primary: '#004455',
                                secondary: '#089ec3',
                                accent: '#ebb306',
                                warning: '#ff8c05',
                                success: '#4CAF50',
                                error: '#D32F2F',
                                info: 'rgba(8, 158, 195, 0.43)',
                                background: '#F5F5F5',
                                surface: '#FFFFFF',
                                gray: '#5e5e5e',
                            },
                        },
                    },
                },
            })

            const app = createApp({
                render() {
                    return h(ConfirmDialog, {
                        title: options.title || 'Confirmation',
                        message: options.message,
                        sessionLabel: options.sessionLabel || '',
                        // L'événement onConfirm résout la promesse avec true
                        onConfirm: () => {
                            resolve(true)
                            app.unmount()
                            container.remove()
                        },
                        // L'événement onCancel résout la promesse avec false
                        onCancel: () => {
                            resolve(false)
                            app.unmount()
                            container.remove()
                        }
                    })
                }
            })

            // Injectez Vuetify dans l'instance dynamique
            app.use(vuetify)
            // Montez l’application
            app.mount(container)
        })
    })
})
